export const CONTACT_NUMBER = '525561469874';
export const CONTACT_MAINTENANCE = `https://api.whatsapp.com/send/?phone=${CONTACT_NUMBER}&text&type=phone_number&app_absent=0`;
export const HELP_ORDER_WHATSAPP_LINK = `https://api.whatsapp.com/send/?phone=${CONTACT_NUMBER}&text=Hola%2C%20necesito%20ayuda%20con%20mi%20pedido`;
